import BaseViewController from "../base-view-controller";

class BasicProfileViewController extends BaseViewController {
  preprocessScreenData() {
    const { fields } = this.screen;

    if (fields.find(f => f.name === "screenTitle")) {
      const AboutYouContainer = fields.find(f => f.name === "name_tile_field")
        .fieldLayouts[0].containerFields;

      const AboutYouTitle = fields.splice(
        fields.findIndex(f => f.name === "screenTitle"),
        1
      );

      AboutYouContainer.unshift(AboutYouTitle[0]);
    }

    if (fields.find(f => f.name === "contactSectionTitle")) {
      const ContactContainer = fields.find(f => f.name === "contact_tile_field")
        .fieldLayouts[0].containerFields;

      const ContactTitle = fields.splice(
        fields.findIndex(f => f.name === "contactSectionTitle"),
        1
      );

      ContactContainer.unshift(ContactTitle[0]);
    }

    if (fields.find(f => f.name === "addressTitle")) {
      const AddressContainer = fields.find(
        f => f.name === "address_title_field"
      ).fieldLayouts[0].containerFields;

      const AddressTitle = fields.splice(
        fields.findIndex(f => f.name === "addressTitle"),
        1
      );

      AddressContainer.unshift(AddressTitle[0]);
    }

    if (fields.find(f => f.name === "accessibility_title")) {
      const AccessibilityContainer = fields.find(
        f => f.name === "accessibility_title_field"
      ).fieldLayouts[0].containerFields;

      const AccessibilityTitle = fields.splice(
        fields.findIndex(f => f.name === "accessibility_title"),
        1
      );

      AccessibilityContainer.unshift(AccessibilityTitle[0]);
    }
  }
}

export default BasicProfileViewController;
